/* eslint-disable */
import React, { useEffect, useState } from "react";
import Select from "react-select";
import AsyncSelect from "react-select/async";
import { reactSelectStyle } from "Config/Config";
import * as url from "helper/UrlHelper";
import { getData, postData, putData } from "utils/Gateway";
import { fetchOptions } from "helper/Common/CommonHelper";
import { getMemberOptions } from "helper/ContactHelper/ContactHelper";

const SaveAllergyPopup = ({
  afterPopupClose = () => {},
  selectedAllergyId = null,
  setSelectedAllergyId = () => {},
}) => {
  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const userObj = {
    label: `${userInfo.name ?? userInfo.email} ${userInfo.surname ?? ""}`,
    value: userInfo._id,
  };

  const [allergyTypes, setAllergyTypes] = useState([]);
  const [allergens, setAllergens] = useState([]);
  const [reactions, setReactions] = useState([]);
  const [severities, setSeverities] = useState([]);
  const [statusOptions, setStatusOptions] = useState([]);

  // Define states for all input fields
  const [allergyType, setAllergyType] = useState(null);
  const [allergen, setAllergen] = useState(null);
  const [reaction, setReaction] = useState(null);
  const [severity, setSeverity] = useState(null);
  const [status, setStatus] = useState(null);
  const [firstOccurrence, setFirstOccurrence] = useState(
    new Date().toISOString().split("T")[0]
  );
  // Add resolvedon state for Last Reaction
  const [resolvedon, setResolvedon] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [comments, setComments] = useState("");
  const [assignTo, setAssignTo] = useState(null);

  const [isSaving, setIsSaving] = useState(false);

  // Async load options for assignee
  const loadAssineeOptions = async (inputValue) => {
    try {
      const options = await getMemberOptions(inputValue);
      return options;
    } catch (error) {
      return [];
    }
  };

  //function for get allergy details
  const getAllergyDetails = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_ALLERGY_BY_ID +
        `/${selectedAllergyId}?token=${token}`;

      console.log("requestUrl", requestUrl);

      const response = await getData(requestUrl);

      console.log("response", response);

      if (response.status) {
        const allergyData = response.data;

        setAllergyType({
          value: allergyData.allergytype,
          label: allergyData.allergytype,
        });

        setAllergen({
          value: allergyData.allergen,
          label: allergyData.allergen,
        });

        setReaction({
          value: allergyData.reaction,
          label: allergyData.reaction,
        });

        setSeverity({
          value: allergyData.severity,
          label: allergyData.severity,
        });

        setStatus({
          value: allergyData.currentstatus,
          label: allergyData.currentstatus,
        });

        setFirstOccurrence(
          allergyData.reportedon
            ? new Date(allergyData.reportedon).toISOString().split("T")[0]
            : ""
        );
        // Set resolvedon from allergyData if available
        setResolvedon(
          allergyData.resolvedon
            ? new Date(allergyData.resolvedon).toISOString().split("T")[0]
            : new Date().toISOString().split("T")[0]
        );
        setComments(allergyData.comments);
        if (allergyData.assignedtovalue) {
          setAssignTo({
            value: allergyData.assignedtovalue,
            label: allergyData.assignedtolabel,
          });
        }
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //function for save allergy
  const saveAllergyHandler = async () => {
    try {
      setIsSaving(true);

      // format date
      const firstOccurrenceFormatted =
        firstOccurrence !== "" ? new Date(firstOccurrence).toISOString() : "";
      const resolvedonFormatted =
        resolvedon !== "" ? new Date(resolvedon).toISOString() : "";

      const apiData = {
        allergytype: allergyType?.value,
        allergen: allergen?.value,
        reaction: reaction?.value,
        severity: severity?.value,
        currentstatus: status?.value,
        reportedon: firstOccurrenceFormatted,
        resolvedon: status?.value === "Resolved" ? resolvedonFormatted : "",
        comments: comments,
        assignto: assignTo ? assignTo.value : null,
      };

      console.log("apiData", apiData);

      let requestUrl = url.API_BASE_URL;

      let response = {};

      if (selectedAllergyId) {
        requestUrl +=
          url.API_UPDATE_ALLERGY + `/${selectedAllergyId}?token=${token}`;

        response = await putData(requestUrl, apiData);
      } else {
        requestUrl += url.API_ADD_ALLERGY + `?token=${token}`;

        response = await postData(requestUrl, apiData);
      }

      setIsSaving(false);

      console.log(response);

      if (response.status) {
        resetHandler();
        //close offcanvas
        bootstrap.Offcanvas.getInstance(
          document.querySelector("#saveAllergyOffCanvas")
        ).hide();
        afterPopupClose([response.data]);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const resetHandler = () => {
    setAllergyType(null);
    setAllergen(null);
    setReaction(null);
    setSeverity(null);
    setStatus(null);
    setFirstOccurrence(new Date().toISOString().split("T")[0]);
    // Reset resolvedon
    setResolvedon("");
    setComments("");
    setAssignTo(null);
    setSelectedAllergyId(null);
  };

  useEffect(() => {
    if (selectedAllergyId) {
      getAllergyDetails();
    }
  }, [selectedAllergyId]);

  useEffect(() => {
    fetchOptions(
      `${url.SERVER_URL}${url.ALLERGY_TYPE_OPTIONS}`,
      setAllergyTypes
    );
    fetchOptions(`${url.SERVER_URL}${url.ALLERGEN_OPTIONS}`, setAllergens);
    fetchOptions(
      `${url.SERVER_URL}${url.ALLERGY_REACTION_OPTIONS}`,
      setReactions
    );
    fetchOptions(
      `${url.SERVER_URL}${url.ALLERGY_SEVERITIES_OPTIONS}`,
      setSeverities
    );
    fetchOptions(
      `${url.SERVER_URL}${url.CONDITION_STATUS_OPTIONS}`,
      setStatusOptions
    );
  }, []);

  return (
    <div
      className="offcanvas lg offcanvas-end bg-white border-0 shadow-lg"
      tabIndex="-1"
      id="saveAllergyOffCanvas"
      aria-labelledby="saveAllergyOffCanvas"
    >
      {/* Header */}
      <div className="offcanvas-header bg-primary text-white p-4 pb-3 border-bottom border-gray-300">
        <div className="d-flex align-items-center gap-3">
          <div className="icon-wrapper p-3 bg-white rounded-circle d-flex align-items-center justify-content-center">
            <span className="material-symbols-outlined text-primary fs-5 icon-md">
              science
            </span>
          </div>
          <div>
            <h3 className="offcanvas-title fw-bold text-white mb-0">
              Save Allergy
            </h3>
            <p className="text-white fs-sm mb-0">
              Add or update allergy details
            </p>
          </div>
        </div>
        <button
          type="button"
          className="btn-close p-2 bg-gray-200 rounded-circle shadow-sm border-0"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
          onClick={resetHandler}
        ></button>
      </div>
      <div className="offcanvas-body p-4">
        <div className="p-3 p-md-4 border border-gray-300 rounded-10 shadow-sm">
          <form onSubmit={(e) => e.preventDefault()}>
            <div className="row">
              <div className="col-md-6">
                <div className="form-group mb-4">
                  <label className="d-block fw-semibold mb-2">
                    Allergy Type <span className="text-danger fw-bold">*</span>
                  </label>
                  <Select
                    isClearable
                    name="allergyType"
                    options={allergyTypes}
                    placeholder="Select Allergy Type"
                    styles={reactSelectStyle("3px", "6px", true, false)}
                    value={allergyType || null}
                    onChange={setAllergyType}
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group mb-4">
                  <label className="d-block fw-semibold mb-2">
                    Allergen <span className="text-danger fw-bold">*</span>
                  </label>
                  <Select
                    isClearable
                    name="allergen"
                    options={allergens}
                    placeholder="Select Allergen"
                    styles={reactSelectStyle("3px", "6px", true, false)}
                    value={allergen}
                    onChange={setAllergen}
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <div className="form-group mb-4">
                  <label className="d-block fw-semibold mb-2">
                    Reaction <span className="text-danger fw-bold">*</span>
                  </label>
                  <Select
                    isClearable
                    name="reaction"
                    options={reactions}
                    placeholder="Select Reaction"
                    styles={reactSelectStyle("3px", "6px", true, false)}
                    value={reaction}
                    onChange={setReaction}
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group mb-4">
                  <label className="d-block fw-semibold mb-2">
                    Severity <span className="text-danger fw-bold">*</span>
                  </label>
                  <Select
                    isClearable
                    name="severity"
                    options={severities}
                    placeholder="Select Severity"
                    styles={reactSelectStyle("3px", "6px", true, false)}
                    value={severity}
                    onChange={setSeverity}
                  />
                </div>
              </div>
            </div>
            <div className="form-group mb-4">
              <label className="d-block fw-semibold mb-2">
                Status <span className="text-danger fw-bold">*</span>
              </label>
              <Select
                isClearable
                name="status"
                options={statusOptions}
                placeholder="Select Status"
                styles={reactSelectStyle("3px", "6px", true, false)}
                value={status}
                onChange={setStatus}
              />
            </div>
            <div className="form-group mb-4">
              <label className="d-block fw-semibold mb-2">
                First Occurrence <span className="text-danger fw-bold">*</span>
              </label>
              <input
                type="date"
                name="firstOccurrence"
                value={firstOccurrence || ""}
                onChange={(e) => setFirstOccurrence(e.target.value)}
                className="form-control fs-sm shadow-none border border-gray-300"
              />
            </div>
            {/* Add Last Reaction field after First Occurrence */}
            <div
              className={
                status?.value === "Resolved" ? "form-group mb-4" : "d-none"
              }
            >
              <label className="d-block fw-semibold mb-2">Last Reaction</label>
              <input
                type="date"
                name="lastreaction"
                value={resolvedon || ""}
                onChange={(e) => setResolvedon(e.target.value)}
                className="form-control fs-sm shadow-none border border-gray-300"
              />
            </div>
            <div className="form-group mb-4">
              <label htmlFor="comments" className="d-block fw-semibold mb-2">
                Comments
              </label>
              <textarea
                name="comments"
                id="comments"
                rows="5"
                placeholder="Enter Comments"
                className="form-control fs-sm shadow-none border border-gray-300"
                value={comments}
                onChange={(e) => setComments(e.target.value)}
              ></textarea>
            </div>
            <div className="form-group mb-4">
              <label className="d-block fw-semibold mb-2">Assign To</label>
              <AsyncSelect
                isClearable
                name="assignTo"
                loadOptions={loadAssineeOptions}
                defaultOptions={false}
                cacheOptions={false}
                placeholder="Select Assignee"
                styles={reactSelectStyle("3px", "6px", true, false)}
                value={assignTo}
                onChange={setAssignTo}
              />
            </div>
            <div
              className={
                allergyType && allergen && reaction && severity && status
                  ? "group_btnOuter d-flex justify-content-end pt-3 border-top mt-auto"
                  : "d-none"
              }
            >
              <button
                type="button"
                className="btn btn-primary d-flex align-items-center gap-2"
                onClick={saveAllergyHandler}
                disabled={isSaving}
                style={{
                  cursor: isSaving ? "not-allowed" : "pointer",
                }}
              >
                {isSaving ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Saving...
                  </>
                ) : (
                  <>
                    <span className="material-symbols-outlined me-1">save</span>
                    Save Allergy
                  </>
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SaveAllergyPopup;
